import { motion } from 'framer-motion';
import { MapPin, Heart } from 'lucide-react';

const familyImages = {
  kidsOutdoor: 'https://customer-assets.emergentagent.com/job_connect-premium-2/artifacts/88l0tqnc_fam%20ily%203.jpg',
  seniors: 'https://customer-assets.emergentagent.com/job_connect-premium-2/artifacts/xym517kz_connect%20family%201.jpg',
};

const WhatToMonitor = () => {
  return (
    <section className="section" data-testid="what-to-monitor-section">
      <div className="container-custom">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-10 md:mb-14"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold text-[#1A1A1A] mb-3">
            What You Can Monitor
          </h2>
          <p className="text-[#5A5A5A] text-base md:text-lg">
            Peace of mind for every family member.
          </p>
        </motion.div>

        {/* Cards Grid */}
        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {/* Kids Care Card */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="monitor-card"
            data-testid="monitor-card-kids"
          >
            <div className="monitor-card-image h-[180px]">
              <img 
                src={familyImages.kidsOutdoor} 
                alt="Parents with children outdoors"
              />
            </div>
            <div className="p-5">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-8 h-8 rounded-lg bg-blue-50 flex items-center justify-center">
                  <MapPin className="w-4 h-4 text-blue-600" />
                </div>
                <h3 className="text-lg font-semibold text-[#1A1A1A]">Kids Care & Location</h3>
              </div>
              <p className="text-[#5A5A5A] text-sm leading-relaxed">
                See your child's location and safe-zone alerts—without constant calls.
              </p>
            </div>
          </motion.div>

          {/* Parents 60+ Card */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.15 }}
            className="monitor-card"
            data-testid="monitor-card-seniors"
          >
            <div className="monitor-card-image h-[180px]">
              <img 
                src={familyImages.seniors} 
                alt="Senior parents together"
              />
            </div>
            <div className="p-5">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-8 h-8 rounded-lg bg-rose-50 flex items-center justify-center">
                  <Heart className="w-4 h-4 text-rose-600" />
                </div>
                <h3 className="text-lg font-semibold text-[#1A1A1A]">Parents 60+ Health</h3>
              </div>
              <p className="text-[#5A5A5A] text-sm leading-relaxed">
                Monitor heart rate patterns and sleep quality, with gentle trend alerts.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhatToMonitor;
